import { axios } from 'lib/axios';
import { toFormData } from './formData';
import { useQnaMutation } from './useQnaMutation';

const updateNotification = (resource, id, { notificationId, ...values }) =>
  axios.put(`/api/${resource}/${id}/qna/notifications/${notificationId}`, toFormData(values));

export const useUpdateNotification = (resource, id, onSuccess) =>
  useQnaMutation(resource, id, (values) => updateNotification(resource, id, values), {
    successMessage: (values) =>
      values.publish ? 'Notification published' : 'Draft notification saved',
    onSuccess,
  });
